<template>
    <div :class="classObj" class="app-wrapper">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <!--v-show="!hidden"  -->
        <sidebar class="sidebar-container"  />
        <!-- :id="hidden?'isHidden':''" -->
        <div :class="{hasTagsView:needTagsView}" class="main-container"  >
            <!-- v-show="!hidden" -->
            <div :class="{'fixed-header':fixedHeader}" >
                <navbar />
                <tags-view v-if="needTagsView" />
            </div>
            <app-main />
            <right-panel v-if="showSettings">
                <settings />
            </right-panel>
        </div>
        <el-tooltip placement="top" content="返回顶部" style="z-index: 99999;">
            <back-to-top :visibility-height="200" :back-position="50" transition-name="fade" />
        </el-tooltip>
        <vxe-modal type='modal' :position="posiud" title="问题解答"
            v-model="showmodel"
            id="myModal_cgtwo" key="mcfs" width="400" height="230"
            :mask="false" :lock-view="false" :showHeade="false" :remember="false"
            resize show-close storage transfer
        >
            <template slot="header">
                <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
                    <div style="color: #fff;">常见问题解答</div>
                    <el-checkbox text-color="#ffffff" v-model="checkedttt" style="padding-left: 104px;color: #fff;">以后不再展示</el-checkbox>
                    <el-button type="text" @click="but" style="margin-left: 37px;color: #fff;">关闭</el-button>
                </div>
            </template>
            <template>
                <el-collapse>
                    <el-collapse-item v-for="(item,index) in options" :key="index" :name="index" >
                        <template slot="title">
                            <span style="float:left;font-weight:bold;font-size:14px;color:#2C8DF4;">{{item.ask}}</span>
                        </template>
                        <div>{{ item.answer }}</div>
                    </el-collapse-item>
                </el-collapse>
            </template>
        </vxe-modal>
        <el-dialog title="通知" :visible.sync="showCode" width="40%">
            <!-- <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="text-align: center; font-size: 16px;">
                    于{{app_time}}日冀视力App版本更新至1.9.2版本请相关医院进行扫码更新
                </div>
                <div style="text-align: center; font-size: 16px;">
                    （本次更新增加了1.儿童入园体检/在园的辅助检查功能2.青少年体检模块）
                </div>
                <img class="myImg" src="https://epochwlkj.com/android.jpg" alt="">
                <div style="text-align: center;color: red; font-size: 16px;">
                    请用手机百度浏览器、QQ浏览器
                </div>
                <div style="text-align: center;color: red; font-size: 16px;">
                    扫一扫下载安装冀视力APP（不支持苹果手机）
                </div>
            </div> -->
            <span style="color: #000;font-size: 16px;">
                    国家卫生健康委办公厅于 2026-07-23 发布关于印发近视防治指南、斜视和弱视诊疗指南（2026年版）的通知。
                
                <a style="color: blue;"
                    href="https://epochwlkj.com/%E8%BF%91%E8%A7%86%E9%98%B2%E6%B2%BB%E6%8C%87%E5%8D%97%EF%BC%882026%E5%B9%B4%E7%89%88%EF%BC%89.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    点击预览《近视防治指南（2026年版）》
                </a>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import BackToTop from '@/components/BackToTop'
    import RightPanel from '@/components/RightPanel'
    import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
    import ResizeMixin from './mixin/ResizeHandler'
    import { mapState } from 'vuex'
    import request from "../utils/request";
    import dayjs from 'dayjs'
    export default {
        name: 'Layout',
        data(){
            return{
                showmodel:true,
                showCode:false,
                options:[],
                posiud:{
                    top:2,
                    left:950
                },
                checkedttt:false,
                app_time:'',
            }
        },
        components: {
            BackToTop,
            AppMain,
            Navbar,
            RightPanel,
            Settings,
            Sidebar,
            TagsView
        },
        mixins: [ResizeMixin],
        computed: {
            ...mapState({
                sidebar: state => state.app.sidebar,
                device: state => state.app.device,
                showSettings: state => state.settings.showSettings,
                needTagsView: state => state.settings.tagsView,
                fixedHeader: state => state.settings.fixedHeader,
                showText: state => state.settings.showText,
                hidden: state => state.settings.hidden,
                modal: state => state.user.modal,
            }),
            classObj() {
                return {
                    hideSidebar: !this.sidebar.opened,
                    openSidebar: this.sidebar.opened,
                    showText: this.showText,
                    withoutAnimation: this.sidebar.withoutAnimation,
                    mobile: this.device === 'mobile'
                }
            }
        },
        created() {
            if(JSON.parse(localStorage.getItem('checkedttt'))==true){
                this.showmodel=false
            }else{
                this.showmodel=true
            }
        },
        mounted(){
            this.getConfig()
        },
        methods: {
            handleClickOutside() {
                this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
            },
            but(){
                localStorage.setItem('checkedttt', this.checkedttt)
                if(this.checked){
                    this.$store.commit('user/SET_modal',false)
                }
                this.showmodel=false
            },
            butCode(){
                this.showCode=false
            },
            getConfig(){
                request({
                    url: 'admin/AdminSysconfig/getConfig',
                    method: 'get',
                    params: {name:'admin_question'}
                }).then((res) => {
                    if (res.code == 200) {
                        this.options=[]
                        let arr=res.data.split('\n')
                        arr.forEach((i)=>{
                            i=i.split('||')
                            this.options.push( { ask:i[0], answer:i[1] } )
                        })
                    }
                })
                request({
                    url: 'admin/AdminSysconfig/getConfig',
                    method: 'get',
                    params: {name:'app_time'}
                }).then((res) => {
                    if (res.code == 200) {
                        this.app_time = res.data;
                        var setTime = dayjs(res.data).unix()+86400;
                        var last_login_time = localStorage.getItem('last_login_time')*1
                        if(setTime >= last_login_time && !(last_login_time == null||last_login_time == ''||last_login_time == undefined||last_login_time == 0)){
                            this.showCode=true
                        }else{
                            this.showCode=false
                        }
                    }
                })
            },
        }
    }
</script>
<style lang="scss">
    ::v-deep .vxe-modal--header {
        background-color: #006c52;
    }
</style>
<style scoped>
    div /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
        /* color: #f0f9f7; */
    }
</style>
<style lang="scss" scoped>
    @import "~@/styles/mixin.scss";
    @import "~@/styles/variables.scss";
    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;

        &.mobile.openSidebar {
            position: fixed;
            top: 0;
        }
    }
    #isHidden{
        margin-left: 0 !important;
    }

    .drawer-bg {
        background: #000;
        opacity: 0.3;
        width: 100%;
        top: 0;
        height: 100%;
        position: absolute;
        z-index: 999;
    }

    .fixed-header {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: calc(100% - #{$sideBarWidth});
        transition: width 0.28s;
    }

    .hideSidebar .fixed-header {
        width: calc(100% - 54px)
    }

    .mobile .fixed-header {
        width: 100%;
    }

    .myImg{
        width: 280px;
        height: 280px;
    }
</style>
